module.exports = __webpack_public_path__ + "static/9a-6613d18be424d48f15c4d406b97ad34d.png";